<template>
  <div class="level-warp">
    <div class="wh-title-one">
      {{ $route.query.title }}
    </div>
    <el-button type="primary" icon="el-icon-plus" class="add-btn" size="mini" @click="addFn()">
      添加标准
    </el-button>
    <wh-list
      ref="myList"
      class="level-list"
      :data-src="dataSrc"
      :extra-params="parameter"
      :get-list-data="getListData"
      :get-total-page-from-response="getTotal"
    >
      <template v-slot:listScope="{ listData }">
        <el-table
          :data="listData"
          border
          class="see-table"
          style="width: 100%;"
          :header-cell-style="tableHeaderCellStyle"
          :cell-style="tableCellStyle"
        >
          <el-table-column prop="index" label="序号" width="80">
            <template slot-scope="scope">
              <div class="wh-flex-center">
                {{ scope.row.index }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="standard_number" label="标准号" width="146" />
          <el-table-column prop="standard_name" label="标准名称" min-width="325" />
          <el-table-column prop="level" label="级别" min-width="188" />
          <el-table-column label="操作" min-width="148">
            <template slot-scope="scope">
              <el-button-group>
                <el-button type="text" style="margin-right: 8px" @click="tapFix(scope.row)">
                  修改
                </el-button>
                <el-button type="text" @click="tapDelete(scope.row)">
                  删除
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </wh-list>
    <el-dialog
      :title="form.type === 'fix' ? '修改标准' : '增加标准'"
      width="600px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标准号" prop="standard_number">
          <el-input v-model="form.standard_number" placeholder="请输入标准号" />
        </el-form-item>
        <el-form-item label="标准名称" prop="standard_name">
          <el-input v-model="form.standard_name" placeholder="请输入标准名称" />
        </el-form-item>
        <el-form-item label="级别" prop="level">
          <el-input v-model="form.level" placeholder="请输入级别" />
        </el-form-item>
        <el-form-item label="上传">
          <wh-uploader
            ref="myUploader"
            class="my-pdf-up"
            :limit="1"
            :not-pic="true"
            :valid-ext="['pdf', 'PDF']"
            :is-private="true"
            :show-file-list="true"
            :preset-file-list="fileList"
            :before-upload-request-handle="beforeUploadFn"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WhList from '@/components/WhList/WhList'
import WhUploader from '@/components/WhUploader/WhUploader'
import { Instance } from '@/service/httpOther'
import { mapState } from 'vuex'
export default {
  name: 'Add',
  components: { WhUploader, WhList },
  props: ['child'],
  data() {
    Instance.defaults.baseURL = Instance.defaults.baseURL.replace('/standard', '') + `/standard`
    return {
      parameter: {
        search: '',
        classification_id: 0
      },
      listData: [],
      dataSrc: Instance,
      dialogVisible: false,
      form: {
        id: 0,
        type: 'add',
        classification_id: parseInt(this.$route.params.child),
        standard_number: 'GB/T 1.1-2009',
        standard_name: '标准化工作导则 第1部分：标准的结构和编写',
        level: '2',
        file: ['http://cdntfjpri.whhda.xyz/20201030155308%E5%A4%A9%E5%BA%9C%E6%A3%80-%E7%A7%BB%E5%8A%A8%E7%AB%AF.pdf?e=1604044579&token=L809vSR9o21wPdoa4t8-VHjIrRECqN0_Fb1MzEvU:L-2U9vuJSVN43NIE3szPbqQLhRw=']
      },
      rules: {
        standard_number: [
          { required: true, message: '请输入标准号', trigger: 'blur' }
        ],
        standard_name: [
          { required: true, message: '请输入标准名称', trigger: 'blur' }
        ],
        level: [
          { required: true, message: '请输入级别', trigger: 'blur' }
        ]
      },
      fileList: []
    }
  },
  computed: {
    ...mapState([
      'upToken'
    ])
  },
  watch: {
    child: {
      handler(newV, oldV) {
        this.parameter.classification_id = newV
      },
      immediate: true
    }
  },
  methods: {
    getListData(res) {
      const resp = res.data
      return resp.data.map((item, index) => {
        return {
          ...item
        }
      })
    },
    getTotal(res) {
      return res.total || 0
    },
    tableCellStyle() {
      return 'border-color: #fff;color: #10132C;'
    },
    // 修改 table header cell的背景色
    tableHeaderCellStyle() {
      return 'border-color: #fff;'
    },
    addFn() {
      this.form = {
        id: 0,
        type: 'add',
        classification_id: parseInt(this.$route.params.child),
        standard_number: '',
        standard_name: '',
        level: '',
        file: {}
      }
      this.fileList = []
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    tapFix(row) {
      this.form = {
        ...this.form,
        ...row
      }
      this.fileList = [{
        name: row.file.key || '',
        url: row.file.url
      }]
      this.form.type = 'fix'
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    tapDelete(row) {
      this.$confirm(`此操作将永久删除该标准, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$Api.deleteStandard({
          id: row.id
        }).then(res => {
          this.$message.success('删除该项成功')
          this.$refs.myList.listDataRequest()
        }).catch(err => {
          console.error(err)
          this.$message.warning('删除该项失败')
        })
      }).catch(() => {})
    },
    sureFn() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const fileList = this.$refs.myUploader.fileListResult
          if (fileList.length) {
            const temp = { ...this.form }
            temp.file = [fileList[0].name]
            if (this.form.type === 'add') {
              this.$Api.postStandard(temp).then(res => {
                this.$message.success('添加成功')
                this.updateData()
              }).catch(err => {
                console.error(err)
                this.$message.warning('添加失败')
              })
            } else if (this.form.type === 'fix') {
              this.$Api.putStandard(temp).then(res => {
                this.$message.success('修改成功')
                this.updateData()
              }).catch(err => {
                console.error(err)
                this.$message.warning('修改失败')
              })
            }
          } else {
            this.$message.warning('上传文件不能为空')
          }
        }
      })
    },
    updateData() {
      this.$refs.myList.listDataRequest()
      this.dialogVisible = false
      this.fileList = []
    },
    handleClose() {
      this.dialogVisible = false
    },
    beforeUploadFn(file) {
      // localStorage.setItem('upFile', deepCopy(file))
      return new Promise((resolve, reject) => {
        const Bearer = `Bearer ` + `${this.upToken.access_token}`
        // 获取Token
        this.$Api.fileToken({
          file_name: file.file.name.replace('%', '').replace(',', ''),
          bucket_name: 'dazhou',
          ...{}
        }, false, {
          headers: {
            Authorization: Bearer
          }
        }).then(res => {
          const fd = new FormData()
          fd.append('file', file.file)
          fd.append('token', res.token)
          fd.append('key', res.key)
          resolve(fd)
        }).catch(err => {
          this.$message.warning('获取token失败:' + err)
          reject(err)
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .level-warp{
    padding: 10px 0 30px;
    .add-btn{
      margin: 10px 20px 10px;
    }
  }
  /deep/.see-table{
    th{
      &:first-child{
        text-align: center;
      }
    }
    tbody tr:hover>td {
      background-color: #EDEDEF!important;
      color: #0074C1!important;
    }
  }
  .level-list{
    padding: 0;
  }
  .my-pdf-up{
    /deep/ .el-icon-delete{
      position: relative;
      left: -30px;
    }
  }
</style>
